import { useEffect } from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { ArrowPathIcon, BanknotesIcon, LockClosedIcon } from '@heroicons/react/20/solid'

const features = [
  {
    name: 'Optimización de Costos',
    description:
      'Reduce gastos operativos con herramientas que optimizan tus recursos y maximizan el retorno de inversión, manteniendo calidad y rendimiento al más alto nivel.',
    href: '#',
    icon: BanknotesIcon,
  },
  {
    name: 'Soporte Continuo',
    description:
      'Soporte post-despliegue para asegurar que tu sistema funcione sin problemas. Nuestro equipo está siempre disponible para resolver cualquier incidencia.',
    href: '#',
    icon: ArrowPathIcon,
  },
  {
    name: 'Protección de Datos',
    description:
      'Seguridad avanzada para tu información. Protegemos tus datos de accesos no autorizados y amenazas cibernéticas con medidas robustas y eficaces.',
    href: '#',
    icon: LockClosedIcon,
  },
]

export default function ProductMain1() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true, easing: 'ease-out-cubic' })
  }, [])

  return (
    <div className="bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-full px-4 sm:px-6 lg:px-10 flex flex-col items-center">

        <div className="max-w-5xl w-full mb-12 text-center" data-aos="fade-up">
          <p className="text-xs font-semibold text-[#366D73] tracking-[0.2em] uppercase mb-4">Implementa rápido</p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#353E40]">
            Todo lo que necesitas para <span className="text-[#366D73]">desplegar</span> tu aplicación
          </h2>
          <p className="mt-6 text-lg text-gray-500 leading-relaxed">
            Desde la integración hasta la gestión, simplificamos el proceso para poner tu producto en producción de manera rápida y efectiva.
          </p>
        </div>

        <dl className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-5xl w-full">
          {features.map((feature, index) => (
            <div
              key={feature.name}
              className="group bg-white rounded-2xl border border-gray-200/60 hover:border-[#366D73]/30 hover:shadow-[0_4px_20px_-8px_rgba(54,109,115,0.15)] transition-all duration-300 p-6 sm:p-8"
              data-aos="fade-up"
              data-aos-delay={index * 80}
            >
              <div className="w-12 h-12 rounded-full bg-[#366D73]/10 flex items-center justify-center mb-5 group-hover:bg-[#366D73]/20 transition-colors">
                <feature.icon className="h-6 w-6 text-[#366D73]" />
              </div>
              <dt className="text-lg font-bold text-[#353E40] mb-3">{feature.name}</dt>
              <dd className="text-sm text-gray-500 leading-relaxed">{feature.description}</dd>
              <a
                href={feature.href}
                className="inline-flex items-center mt-6 text-sm font-semibold text-[#366D73] hover:text-[#3B8C8C] transition-colors duration-200 gap-1 group-hover:gap-2 transition-all"
              >
                Saber más <span className="inline-block">→</span>
              </a>
            </div>
          ))}
        </dl>

        {/* CTA - Novedades */}
        <div className="mt-16 flex justify-center" data-aos="fade-up" data-aos-delay="200">
          <div className="relative overflow-hidden bg-[#353E40] rounded-2xl px-8 py-12 sm:px-16 sm:py-12 text-center max-w-3xl w-full">
            <div className="absolute -top-24 -left-24 h-64 w-64 rounded-full bg-[#366D73]/20 blur-3xl" />
            <div className="absolute -bottom-24 -right-24 h-64 w-64 rounded-full bg-[#366D73]/15 blur-3xl" />

            <p className="relative text-xs font-semibold text-[#07F2F2] tracking-[0.2em] uppercase mb-3">Novedades</p>
            <h2 className="relative text-2xl sm:text-3xl font-bold text-white leading-[1.15]">
              Sé el primero en saber cuando lanzamos algo <span className="text-[#07F2F2]">nuevo</span>
            </h2>
            <p className="relative mt-2 text-gray-400 text-sm max-w-sm mx-auto">
              ¿Quieres estar al día con nuestras novedades? Regístrate aquí.
            </p>

            <form className="relative mx-auto mt-6 flex flex-col sm:flex-row max-w-sm gap-2 w-full">
              <input
                id="email-address"
                name="email"
                type="email"
                required
                placeholder="tu@correo.com"
                autoComplete="email"
                className="flex-1 rounded-xl border border-white/10 bg-white/10 px-4 py-2.5 text-white placeholder:text-gray-500 text-sm focus:outline-none focus:ring-2 focus:ring-[#07F2F2]/50 transition-all duration-200"
              />
              <button
                type="submit"
                className="rounded-xl bg-white px-5 py-2.5 text-sm font-semibold text-[#353E40] hover:bg-gray-100 transition-colors duration-200 whitespace-nowrap sm:whitespace-normal w-full sm:w-auto"
              >
                Suscribirse
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}